import { mapActions, mapGetters, mapState } from "vuex";

export const jobWarnings = {
  computed: {
    ...mapState(["job"]),
    ...mapGetters(["jobStatusEnabled"])
  },
  methods: {
    ...mapActions(["withImportedDataWarning", "withJobStatusFinalWarning"]),

    async withJobWarnings({ action, record, context }) {
      let noWarningTriggered = true;

      for (const warning of this.warnings(action, record, context)) {
        try {
          if (warning.condition) {
            noWarningTriggered = false;
            await warning.handler();
            break;
          }
        } catch (e) {
          if (e.result !== "cancel") {
            throw e;
          }
        }
      }

      if (noWarningTriggered) {
        await action();
      }
    },
    warnings(action, record, context) {
      return [
        {
          condition: record.imported,
          handler: () =>
            this.withImportedDataWarning({
              action,
              record,
              context
            })
        },
        {
          condition: this.jobStatusEnabled && this.job.status?.final,
          handler: () =>
            this.withJobStatusFinalWarning({
              action,
              record: this.job,
              context
            })
        }
      ];
    }
  }
};
